import {put} from "redux-saga/effects"
import axios from "axios"
import moment from "moment"
import {FETCH_CURRENT_COUNTRY_SUCCESS, MOBILE_DETAILS} from "../actions/types"

export function* fetchCurrentCountry() {
    try {
        const result = yield axios.get("https://ipapi.co/json/?key=tesnYsAuM2AmauPXBln5gHdcqpHLDXWNbpdbIWKCOvSHCJstne")
        yield put({type: FETCH_CURRENT_COUNTRY_SUCCESS, data: result.data.country_code})
        yield put({type: MOBILE_DETAILS, payload: {country: result.data.country_code}})
    } catch (error) {
        console.log("Error", error)
    }
}

export const numberWithCommas = (x) => {
    if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
}

export const reloadPage = () => {
    window.location.reload()
}

export const dateString = (date) => {
    return moment(new Date(date)).format("ddd, Do MMMM YYYY")
}
